/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APITicketStatusEnum } from './APITicketStatusEnum';
import {
    APITicketStatusEnumFromJSON,
    APITicketStatusEnumFromJSONTyped,
    APITicketStatusEnumToJSON,
} from './APITicketStatusEnum';
import type { APITypeEnum } from './APITypeEnum';
import {
    APITypeEnumFromJSON,
    APITypeEnumFromJSONTyped,
    APITypeEnumToJSON,
} from './APITypeEnum';

/**
 * Serializer for Ticket model.
 * @export
 * @interface APITicket
 */
export interface APITicket {
    /**
     * 
     * @type {string}
     * @memberof APITicket
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APITicket
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicket
     */
    readonly response: string;
    /**
     * 
     * @type {Date}
     * @memberof APITicket
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APITicket
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {APITypeEnum}
     * @memberof APITicket
     */
    type: APITypeEnum;
    /**
     * 
     * @type {string}
     * @memberof APITicket
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof APITicket
     */
    message: string;
    /**
     * 
     * @type {APITicketStatusEnum}
     * @memberof APITicket
     */
    readonly status: APITicketStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof APITicket
     */
    shared?: boolean;
}



/**
 * Check if a given object implements the APITicket interface.
 */
export function instanceOfAPITicket(value: object): value is APITicket {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('response' in value) || value['response'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function APITicketFromJSON(json: any): APITicket {
    return APITicketFromJSONTyped(json, false);
}

export function APITicketFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicket {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'user': json['user'] == null ? undefined : json['user'],
        'response': json['response'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'type': APITypeEnumFromJSON(json['type']),
        'subject': json['subject'],
        'message': json['message'],
        'status': APITicketStatusEnumFromJSON(json['status']),
        'shared': json['shared'] == null ? undefined : json['shared'],
    };
}

export function APITicketToJSON(value?: Omit<APITicket, 'self'|'response'|'created_at'|'last_modified_at'|'status'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'user': value['user'],
        'type': APITypeEnumToJSON(value['type']),
        'subject': value['subject'],
        'message': value['message'],
        'shared': value['shared'],
    };
}

